function initGA4WithRetry(maxRetries = 3) {
    let retries = 0;
    
    function tryInit() {
        if (typeof gtag !== 'undefined') {
            gtag('config', 'G-7YQ17M61WV');
            console.log('GA4 configured successfully');
            return true;
        }
        
        retries++;
        if (retries < maxRetries) {
            console.log(`Retrying GA4 init (${retries}/${maxRetries})`);
            setTimeout(tryInit, 500);
        } else {
            console.error('GA4 init failed after retries');
        }
        return false;
    }
    
    tryInit();
}

initGA4WithRetry();

// Event mapping base on href
const eventMapping = {
    '/collections/wine-bundles': 'Wine_Bundles',
    '/collections/spirit-bundles': 'Spirit_Bundles'
};

// Get event name from URL
function getEventNameFromUrl(url) {
    try {
        const urlObj = new URL(url);
        const pathname = urlObj.pathname;
        
        // Find exact match first
        if (eventMapping[pathname]) {
            return eventMapping[pathname];
        }
        
        // If not exact match, find partial match
        for (const [path, eventName] of Object.entries(eventMapping)) {
            if (pathname.includes(path)) {
                return eventName;
            }
        }
        
        // Fallback
        return '';
    } catch (error) {
        console.error('Error parsing URL:', error);
        return '';
    }
}

// Utility function to send GA4 event safely
function sendGA4Event(eventName, eventParams = {}) {
    if (typeof gtag !== 'undefined' && eventName) {
        gtag('event', eventName, eventParams);
    }
}

// Event delegate for hero__link clicks 
document.addEventListener('click', function(event) {
    if (event.target.tagName === 'A') {
        // Find closest element has class hero__link
        const heroLink = event.target.closest('.hero__link');
        
        if (heroLink) {
            const linkText = event.target.textContent.trim();
            const linkUrl = event.target.href;
            
            const eventName = getEventNameFromUrl(linkUrl);
            
            if (eventName) {
                sendGA4Event(eventName);
            }
        }
    }
});
